export function bySelector(selector: string) {
    return (element: Element) => element.matches && element.matches(selector);
}

export function byVisibility(visible = true) {
    return (element: HTMLElement) => !!element.offsetParent === visible;
}
